import { ADULT_SCHOOL_SURVEY, JUNIOR_SCHOOL_SURVEY } from "constants/common";

export const SURVEY_PHASE_INTERMEDIATE_TRANSLATE = {
  SCREEN_TITLE_PHASE_1: "ジム (アンケート１回目)",
  SCREEN_TITLE_PHASE_2: "ジム (アンケート２回目)",
  SCREEN_TITLE_JUNIOR: JUNIOR_SCHOOL_SURVEY,
  SCREEN_TITLE_ADULT: ADULT_SCHOOL_SURVEY,
};
